import { cn as e } from "../lib/utils.js";
import { jsx as t } from "react/jsx-runtime";
//#region src/shadcn/skeleton.tsx
function n({ className: n, ...r }) {
	return /* @__PURE__ */ t("div", {
		className: e("animate-pulse rounded-md bg-core-decorative", n),
		...r
	});
}
//#endregion
export { n as Skeleton };
